import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { getMe, loadStoredToken, clearAuthToken } from './api';
import Login from './pages/Login';
import ConfirmPassword from './pages/ConfirmPassword';
import ServerManagement from './pages/ServerManagement';
import CloudServerIP from './pages/CloudServerIP';
import UpdateServerDetails from './pages/UpdateServerDetails';
import Layout from './components/Layout';

export default function App() {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = loadStoredToken();
    if (!token) { setLoading(false); return; }
    getMe()
      .then(r => setUser(r.data && typeof r.data === 'object' ? r.data : null))
      .catch(() => { clearAuthToken(); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="d-flex justify-content-center align-items-center vh-100"><div className="spinner-border text-primary"/></div>;

  return (
    <BrowserRouter basename={process.env.REACT_APP_BASENAME || ''}>
      <Routes>
        <Route path="/login"            element={!user ? <Login onLogin={setUser} /> : <Navigate to="/" />} />
        <Route path="/confirm-password" element={<ConfirmPassword />} />
        <Route path="/"  element={user ? <Layout user={user} setUser={setUser} /> : <Navigate to="/login" />}>
          <Route index                          element={<Navigate to="/server-management" />} />
          <Route path="server-management"       element={<ServerManagement />} />
          <Route path="cloud-server-ip"         element={<CloudServerIP />} />
          <Route path="update-server-details"   element={<UpdateServerDetails />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
